var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApplicationTableCustomField',{attrs:{"fieldType":"beneficiary","items":_vm.dataObj.item.form.beneficiary_users}})}
var staticRenderFns = []

export { render, staticRenderFns }